import { ExternalLinksWidget } from '@/components/external-links-widget/external-links-widget';
import { projectIdState } from '../../project.state';
import { useAddProjectExternalLink } from './use-add-project-external-link.mutation';
import { useProjectExternalLinks } from './use-project-external-links.query';
import { useRemoveProjectExternalLink } from './use-remove-project-external-link.mutation';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { useAtomValue } from 'jotai';

export const ProjectExternalLinksWidget = ({
  className,
  height,
  listMaxHeight,
}: {
  className?: string;
  height?: number;
  listMaxHeight?: number;
}) => {
  const projectId = useAtomValue(projectIdState);
  const { data: externalLinks, isLoading } = useProjectExternalLinks();
  const { mutateAsync: addExternalLink } = useAddProjectExternalLink();
  const { mutateAsync: removeExternalLink } = useRemoveProjectExternalLink();
  const { hasRequiredPermission } = useUserPermissions();
  const hasEditPermission = hasRequiredPermission(PERMISSION.EDIT_PROJECT);

  const handleAddLink = async (link: string, title?: string | null) => {
    await addExternalLink({
      projectId: projectId ?? '',
      data: { urlValue: link, title: title ?? null },
    });
  };

  const onRemoveLink = async (id: string) =>
    await removeExternalLink({ projectId: projectId ?? '', linkId: id });

  return (
    <ExternalLinksWidget
      addLinkHandler={handleAddLink}
      removeLinkHandler={onRemoveLink}
      disabled={!hasEditPermission}
      isLoading={isLoading}
      linksData={externalLinks ?? []}
      emptyStateConfig={{
        direction: 'row',
        labelAlign: 'left',
      }}
      className={className}
      height={height ?? 260}
      listMaxHeight={listMaxHeight ?? 109}
      smallHeader
      data-testid="project-external-links-widget"
    />
  );
};
